import { formatISODate } from "@clipboard-health/date-time";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// eslint-disable-next-line no-restricted-imports -- parseISO treats date-only strings as local time, unlike new Date() which uses UTC
import { parseISO } from "date-fns";
import { Controller } from "react-hook-form";

import { FieldShell } from "./FieldShell";
import {
  buildFieldIds,
  getNestedError,
  hasNonEmptyDescription,
  type SchemaFieldProps,
} from "./utils";

export function DateField({
  fieldKey,
  property,
  fieldPath,
  isRequired,
  control,
  errors,
}: SchemaFieldProps) {
  const errorMessage = getNestedError(errors, fieldPath);
  const { describedBy } = buildFieldIds(fieldPath, hasNonEmptyDescription(property.description));

  return (
    <FieldShell
      fieldKey={fieldKey}
      descriptionId={describedBy}
      isRequired={isRequired}
      description={property.description}
    >
      <Controller
        name={fieldPath}
        control={control}
        rules={isRequired ? { required: "This field is required" } : undefined}
        defaultValue=""
        render={({ field }) => (
          <DatePicker
            label={fieldKey}
            value={field.value ? parseISO(field.value as string) : null}
            format="yyyy-MM-dd"
            inputRef={field.ref}
            slotProps={{
              textField: {
                name: field.name,
                required: isRequired,
                size: "small",
                error: Boolean(errorMessage),
                helperText: errorMessage,
                inputProps: { "aria-describedby": describedBy },
                sx: { width: 300 },
                onBlur: field.onBlur,
              },
            }}
            onChange={(date: Date | null) => {
              if (date && !Number.isNaN(date.getTime())) {
                field.onChange(formatISODate(date));
              } else {
                field.onChange("");
              }
            }}
          />
        )}
      />
    </FieldShell>
  );
}
